export default __webpack_public_path__ + "static/media/006-about-noun_Hire-Car_121692-1-1.fefbf324.webp";